<template>
    <payouts-find
        :params="{ payout: $route.params.payout }"
        :include="[
            'destination',
            'transactions(include:transactionable(include:charge(include:payer),properties))',
        ]"
    >
        <div
            slot-scope="{
                is_loading,
                has_loaded,
                error,
                data: payout,
                find
            }"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <grid-layout>
                    <grid-layout-item class="md:w-2/3 mb-6">
                        <details-card class="md:h-full">
                            <template slot="header">
                                <h1 class="text-lg font-normal">
                                    Money Out
                                </h1>
                            </template>

                            <template slot="body">
                                <grid-layout class="-mt-3">
                                    <grid-layout-item class="md:w-1/2 mt-3">
                                        <div class="text-label text-xs">Destination</div>
                                        <div class="text-sm">
                                            {{ payout.destination.bank_name }}
                                        </div>
                                    </grid-layout-item>

                                    <grid-layout-item class="md:w-1/2 mt-3">
                                        <div class="text-label text-xs">Statement Descriptor</div>
                                        <div class="text-sm">
                                            {{ payout.destination.bank_name }}
                                        </div>
                                    </grid-layout-item>
                                </grid-layout>
                            </template>
                        </details-card>
                    </grid-layout-item>

                    <grid-layout-item class="md:w-1/3 mb-6">
                        <div class="flex flex-col bg-white h-full rounded shadow">
                            <header class="flex-none flex items-center h-16 md:h-18 px-4 sm:px-6 border-b">
                                <h3 class="flex-grow text-base font-normal">Amount</h3>

                                <span
                                    :class="['bg-green-lighter', 'text-green-darker']"
                                    class="flex-none text-sm font-semibold px-3 py-1 rounded-full"
                                >
                                    {{ payout.status }}
                                </span>
                            </header>

                            <div class="flex-grow flex items-center leading-none p-4 sm:p-6">
                                <div class="flex-none">
                                    <div class="text-3xl font-semibold">{{ payout.amount | money(0) }}</div>
                                </div>
                            </div>
                        </div>
                    </grid-layout-item>
                </grid-layout>

                <div class="bg-white rounded shadow mb-6">
                    <header class="flex items-center bg-white rounded-t border-b h-16 px-4 sm:px-6">
                        <h3 class="text-base font-normal">Payments</h3>
                    </header>

                    <transactions-list :transactions="payout.transactions.data" />
                </div>
            </template>
        </div>
    </payouts-find>
</template>

<script>
    import DetailsCard from '../../../../components/details-card'
    import PayoutsFind from '../../../../components/payouts-find'
    import TransactionsList from '../../../../components/transactions-list'

    export default {
        components: {
            DetailsCard,
            PayoutsFind,
            TransactionsList
        }
    }
</script>
